module.exports = __webpack_public_path__ + "static/media/16-Made4u.908f7497.png";